import API from 'app/services/server/serverApi'

/**
 * Zostały tu wyłącznie operacje na użytkownikach serwera.
 *
 * Lista serwerów, dodawanie, edycja i usuwanie przeniosły się do react-query
 * (`app/containers/administration/serverQueries.ts`) razem ze slice'em `servers`.
 * Te dwie nigdy nie dotykały stanu — dispatchowały tylko po to, żeby dostać `dispatch`
 * z thunka, a zwracały wynik wywołania API.
 */
export const getServerUsers = async (serverId: string): Promise<any> => {
  const api = API.create()
  const response = await api.getServerUsers(serverId)
  return response.content.data
}

export const setServerUsers = async (
  serverId: string,
  userIds: string[],
): Promise<void> => {
  const api = API.create()
  await api.setServerUsers(serverId, userIds)
}
